module.exports = __webpack_public_path__ + "img/41_34.410facef.png";